import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";
import { Send, PhoneCall, FileText, Wrench } from "lucide-react";

const ICONS = [Send, PhoneCall, FileText, Wrench];

const ProcessTimeline = () => {
  const { t } = useLanguage();
  const steps = [1, 2, 3, 4].map((n, i) => ({
    Icon: ICONS[i],
    title: t(`process.s${n}.title`),
    desc: t(`process.s${n}.desc`),
  }));

  return (
    <section
      id="process"
      data-testid="process-section"
      className="container-px mx-auto max-w-7xl py-24 lg:py-32"
    >
      <div className="max-w-2xl">
        <p className="text-xs uppercase tracking-[0.22em] text-sky-700 font-medium">
          {t("process.eyebrow")}
        </p>
        <h2 className="font-display mt-3 text-4xl lg:text-6xl font-light tracking-tighter text-neutral-950 text-balance">
          {t("process.title")}
        </h2>
      </div>

      <div className="mt-14 relative">
        <div className="hidden lg:block absolute top-7 left-7 right-7 h-px bg-gradient-to-r from-neutral-200 via-sky-500/50 to-neutral-200" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="relative"
              data-testid={`process-step-${i}`}
            >
              <div className="w-14 h-14 rounded-full bg-white border-2 border-sky-500 text-sky-700 grid place-items-center relative z-10">
                <s.Icon className="w-5 h-5" />
              </div>
              <div className="mt-5">
                <div className="text-xs uppercase tracking-[0.2em] text-neutral-400">
                  Schritt 0{i + 1}
                </div>
                <h3 className="font-display mt-2 text-xl font-medium text-neutral-950">
                  {s.title}
                </h3>
                <p className="mt-2 text-neutral-600 text-[15px] leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessTimeline;
